import { UserBaseAuthPhone } from "@/commons/interfaces";
import { inject, InjectionKey, provide, reactive, ref } from "vue";
import { SidUserClient } from "@sid/sid_client";

const AuthPhoneItemKey: InjectionKey<AuthPhoneItem> = Symbol("AuthPhoneItem");

export class AuthPhoneItem {

    public static create(...dummy: any[]) {
        return new AuthPhoneItem();
    }

    public static inject(): AuthPhoneItem {
        const info = inject(AuthPhoneItemKey);
        if (info) {
            return info;
        }
        throw new Error("not provided.");
    }

    public readonly authPhone = reactive(new UserBaseAuthPhone())

    public readonly agreement = ref(false);

    public setAuthPhone(userAuthPhoneVal: UserBaseAuthPhone) {
        this.authPhone.phoneNumber = userAuthPhoneVal.phoneNumber;
    }

    public async fetch(sidClient: SidUserClient) {
        const response = await sidClient.requestApi({ method: "GET", path: "/user/auth_phone" }).then(res => res.data).catch(e => new UserBaseAuthPhone());
        this.setAuthPhone(response);
        return response;
    }

    public provide() {
        provide(AuthPhoneItemKey, this);
    }
}